export default "__VITE_ASSET__D7PPP$D2__"